module.exports = __webpack_public_path__ + "static/media/crownlogodarktransp.c6bf57a2.png";